const STORAGE_PREFIX = "labwick-inbox-auto-quick-add-dashboard:";
const LEGACY_STORAGE_PREFIX = "labwick-inbox-auto-dump-dashboard:";

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}${userId}`;
}

function legacyStorageKey(userId: string): string {
  return `${LEGACY_STORAGE_PREFIX}${userId}`;
}

export function loadAutoOpenQuickAddOnDashboard(userId: string | null | undefined): boolean {
  if (!userId) return false;
  try {
    const value = localStorage.getItem(storageKey(userId));
    if (value !== null) {
      return value === "true";
    }
    return localStorage.getItem(legacyStorageKey(userId)) === "true";
  } catch {
    return false;
  }
}

export function saveAutoOpenQuickAddOnDashboard(
  userId: string | null | undefined,
  enabled: boolean
): void {
  if (!userId) return;
  try {
    localStorage.setItem(storageKey(userId), enabled ? "true" : "false");
  } catch {
    // Ignore quota / private mode errors
  }
}
